import { BaseEntity } from '~/lib/model/base';
import { IAction } from './common';

export enum TenderRegion {
  WA = 'WA',
  NEM = 'NEM'
}

export enum ServiceType {
  ELECTRICITY = 'ELECTRICITY',
  GAS = 'GAS',
  DMA = 'DMA'
}

export enum ServiceCategory {
  SMALL = 'SMALL',
  LARGE = 'LARGE'
}

export enum FeePeriod {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL'
}

export enum GreenBillingCalculation {
  DLF_MLF = 'DLF_MLF',
  DLF = 'DLF',
  MLF = 'MLF'
}

export enum InstalmentPeriodType {
  ALL = 'ALL',
  UP_TO = 'UP_TO',
  ABOVE = 'ABOVE'
}

export enum InstalmentSplitType {
  MONTH = 'MONTH',
  PERCENTAGE = 'PERCENTAGE'
}

export enum InstalmentTriggerPoint {
  SIGNED_DATE = 'SIGNED_DATE',
  CSD = 'CSD',
  CED = 'CED',
  MID_POINT = 'MID_POINT'
}

export enum InstalmentUsageType {
  ACTUAL = 'ACTUAL',
  ESTIMATED = 'ESTIMATED'
}

export interface IRetailerContractInstalmentRuleItem {
  month?: number;
  percentage?: number;
  triggerPoint?: InstalmentTriggerPoint;
  usageType: InstalmentUsageType;
}

export interface IRetailerContractInstalmentRule {
  periodType: InstalmentPeriodType;
  periodByMonth?: number;
  splitType: InstalmentSplitType;
  rules: IRetailerContractInstalmentRuleItem[];
}

export interface IRetailerContact {
  id: string;
  name: string;
  position: string;
  phone: string;
  mobile: string;
  fax: string;
  email: string;
  precedence: number;
  salutation: string;
  description: string;
}

export interface IRetailerContract {
  id: string;
  serviceType: ServiceType;
  serviceCategory?: ServiceCategory;
  // dd/MM/yyyy
  contractStartDate: string;
  // dd/MM/yyyy
  contractEndDate: string;
  instalmentRules?: IRetailerContractInstalmentRule[];
  description: string;
}

export interface IRetailerElectricityContract {
  externalRef: string;
  nmiId: string;
  nmiNumber: string;
  retailer: any;
  contractStartDate: string;
  contractEndDate: string;
  sourceOfContract: string;
  contractStatus: string;
  contractType: string;
  contractCategory: string;
  retailTariffDesc: string;
  specialConditions: string;
  usage: 0;
  dmaStartDate: string;
  dmaEndDate: string;
}
export interface IRetailerGasContract {
  externalRef: string;
  mirnId: string;
  mirnNumber: string;
  retailer: any;
  contractStartDate: string;
  contractEndDate: string;
  sourceOfContract: string;
  contractStatus: string;
  contractType: string;
  contractCategory: string;
  retailTariffDesc: string;
  specialConditions: string;
  usage: 0;
}

export interface IRetailerBasic {
  id: string;
  name: string;
  tenderRegion: TenderRegion[];
  meteringFeePeriod?: FeePeriod;
  meteringFeePrice?: number;
  suppDMAOrRPFeePeriod?: FeePeriod;
  suppDMAOrRPFeePrice?: number;
  serviceFeePeriod?: FeePeriod;
  serviceFeePrice?: number;
  greenBilling?: GreenBillingCalculation;
}

export interface IRetailer extends IRetailerBasic {
  contacts: IRetailerContact[];
  contracts: IRetailerContract[];
  action: IAction;
}

export interface IRetailerCreateRequest {
  name: string;
  tenderRegion: TenderRegion[];
  contacts?: Pick<IRetailerContact, 'name' | 'position' | 'phone' | 'mobile' | 'fax' | 'email' | 'precedence'>[];
  contracts?: Pick<
    IRetailerContract,
    'serviceType' | 'serviceCategory' | 'contractStartDate' | 'contractEndDate' | 'instalmentRules'
  >[];
}

export type IRetailerUpdateRequest = IRetailerCreateRequest;

export class Retailer extends BaseEntity implements IRetailer {
  id!: string;
  name!: string;
  tenderRegion!: TenderRegion[];
  meteringFeePeriod?: FeePeriod;
  meteringFeePrice?: number;
  suppDMAOrRPFeePeriod?: FeePeriod;
  suppDMAOrRPFeePrice?: number;
  serviceFeePeriod?: FeePeriod;
  serviceFeePrice?: number;
  greenBilling?: GreenBillingCalculation;
  contacts!: IRetailerContact[];
  contracts!: IRetailerContract[];
  electricityContracts?: IRetailerElectricityContract[];
  gasContracts?: IRetailerGasContract[];
  action!: IAction;
}

export interface IRetailerOutlineResponse {
  id: string;
  name: string;
  // TODO: change to array after backend refactored.
  tenderRegion?: string;
}
